import React from 'react';
import { AdminPageHeader } from '../../../ui';
import { DashboardActions } from './DashboardActions';

/**
 * DashboardManagement - Main admin dashboard component
 */
export const DashboardManagement: React.FC = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 py-6">
      <AdminPageHeader
        title="Dashboard"
        subtitle="Visão geral do sistema"
      />

      <DashboardActions />
    </div>
  );
};

export default DashboardManagement;
